import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { optimizeImageUrl } from "@faire/web/common/transform-images";

import { MaybeFaireDirectBrandBannerImage } from "./MaybeFaireDirectBrandBannerImage";

export const MaybeFaireDirectBrandBannerImageWithHook: React.FC = () => {
  const { faireDirectBrand } = useFaireDirectBrand();

  if (!faireDirectBrand?.banner_image) {
    return null;
  }

  const bannerImageSrc = optimizeImageUrl(
    faireDirectBrand.banner_image,
    false,
    {
      height: 120,
    }
  );

  return <MaybeFaireDirectBrandBannerImage bannerImageSrc={bannerImageSrc} />;
};
